import React from 'react';
import { BellOutlined, LoadingOutlined } from '@ant-design/icons';
import { Button, Badge, Spin } from 'antd';
import { Container } from './styles';

interface AlarmNotificationProps {
  count?: number;
  isMobileMenu?: boolean;
  isLoading?: boolean;
}

export default function AlarmNotification({
  count = 0,
  isMobileMenu = false,
  isLoading = false,
}: AlarmNotificationProps) {
  return (
    <Container>
      <Badge count={count} size="small" offset={[-8, 6]} overflowCount={9}>
        <Button
          icon={
            isLoading ? (
              <Spin size="default" indicator={<LoadingOutlined />} />
            ) : (
              <BellOutlined />
            )
          }
          style={{
            marginLeft: isMobileMenu ? 0 : 8,
            marginBottom: isLoading && !isMobileMenu ? 18 : 0,
          }}
        />
      </Badge>
    </Container>
  );
}
